exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-loader{position:fixed;top:0;left:0;width:100%;height:100%;background:#fff;z-index:999}.app-loader>div{width:150px;height:150px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.app-loader>div p{text-align:center;text-transform:uppercase;font-weight:bolder;color:#1e88e5}.app-loader svg path{fill:#1e88e5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f4ca22ca","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app-loader.vue
// module id = 60
// module chunks = 0